import React from "react";
import { useSelector } from "react-redux";
import { DashboardPartsInventoryTable } from "../Inventory/Table";
import { useDispatch } from "react-redux";

import { RootState } from "../../../../redux";
import { listPartsRequest } from "../../../../redux/parts/actions";


const DashboardPartsInventory = () => {
    const { parts_inventory } = useSelector((state: RootState) => state.parts);
    const dispatch = useDispatch();

    const handleRefresh = () => {
        dispatch(
            listPartsRequest({
                filters: "",
                part_fields: "",
                excludes: "signed_by:null",
                save_as: "parts_inventory"
            })
        );
    };

    React.useEffect(() => {
        handleRefresh();
    }, [dispatch]);

    return (
        <div className="flex flex-col gap-y-5 mt-5 text-black w-full">
            <DashboardPartsInventoryTable
                title="Parts Inventory"
                description="View all the parts in the inventory"
                parts={parts_inventory}
                save_as="parts_inventory"
                handleRefresh={handleRefresh}
            />
        </div>
    );
};

export default DashboardPartsInventory;
